import React from 'react'
import { node, array, string, bool, object } from 'prop-types'
import { connect } from 'react-redux'
import { css } from '@emotion/react'
import { ToastWrapper } from '@livechat/design-system-react-components'

import { canUseWindow } from 'gatsby-theme-marketplace-base/src/utils/browser/window'
import {
  VIEW_MODES,
  DESIGN_SYSTEM_THEME,
} from 'gatsby-theme-marketplace-base/src/constants'
import GlobalStyles from 'gatsby-theme-marketplace-base/src/layout/global-styles'
import SidebarNav from '../components/SidebarNav'
import {
  containerStyles,
  mainStyles,
  mainEmbeddedStyles,
  contentStyles,
} from './layout-styles'

const toastCss = css`
  z-index: 1100;
`

const Layout = ({
  children,
  notifications,
  app,
  expert,
  service,
  category,
  developer,
  cart,
  headerLabel = 'Marketplace',
  showCart = true,
  viewMode,
  showSidebarMenu = true,
  hideBottomPadding,
  className,
}) => {
  if (canUseWindow) {
    const LC_API = window.LC_API || {}

    LC_API.on_before_load = () => {
      LC_API.hide_chat_window()
    }
  }

  let mainStyle

  switch (viewMode) {
    case VIEW_MODES.EMBEDDED:
      mainStyle = [mainStyles(showSidebarMenu), mainEmbeddedStyles]
      break

    default:
      mainStyle = mainStyles(showSidebarMenu)
  }

  return (
    <>
      <ToastWrapper
        fixed={true}
        verticalPosition="top"
        horizontalPosition="center"
        toasts={notifications}
        css={toastCss}
      />
      <GlobalStyles />

      <div
        css={containerStyles}
        className={`${className} ${DESIGN_SYSTEM_THEME}`}
      >
        {![VIEW_MODES.EMBEDDED].includes(viewMode) && (
          <SidebarNav
            app={app}
            expert={expert}
            service={service}
            developer={developer}
            category={category}
            cart={cart}
            headerLabel={headerLabel}
            showCart={showCart}
            showSidebarMenu={showSidebarMenu}
          />
        )}

        <main css={mainStyle}>
          <div css={contentStyles(hideBottomPadding)}>{children}</div>
        </main>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    notifications: state.notifications.items,
  }
}

Layout.propTypes = {
  children: node,
  notifications: array,
  app: object,
  expert: object,
  service: object,
  category: object,
  developer: object,
  cart: object,
  headerLabel: string,
  showCart: bool,
  viewMode: string,
  hideBottomPadding: bool,
  showSidebarMenu: bool,
  className: string,
}

export default connect(mapStateToProps, null)(Layout)
